import { TEXT_MUTED, BORDER, GRADIENT_BG } from "../theme";

function QuestionPrompt({ question, onAnswer }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 50,
      background: GRADIENT_BG,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "24px",
    }}>
      <div style={{ fontSize: "0.75rem", color: TEXT_MUTED, marginBottom: "10px" }}>today's question</div>
      <div style={{ fontSize: "1.0625rem", fontWeight: "700", marginBottom: "26px", textAlign: "center", maxWidth: "380px" }}>
        {question.text}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%", maxWidth: "320px" }}>
        {question.choices.map((choice) => (
          <button
            key={choice}
            onClick={() => onAnswer(choice)}
            style={{ padding: "12px", background: "#fff", border: `1px solid ${BORDER}`, borderRadius: "10px", fontWeight: "600", fontSize: "0.875rem" }}
          >
            {choice}
          </button>
        ))}
      </div>
    </div>
  );
}

export default QuestionPrompt;
